import styled from 'styled-components';

import { blockingColors, blockingMetrics } from 'design-system/tokens';

export const Container = styled.div`
  margin-top: 24px;
  display: flex;
  flex-direction: column;
  gap: 12px;

  height: 500px;
  overflow: auto;
  padding-right: 8px;

  &::-webkit-scrollbar {
    width: 12px;
  }

  &::-webkit-scrollbar-track {
    background: #e9e9e9;
    border-radius: 6px;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #0b29fb;
    border-radius: 6px;
    border: 2px solid #e9e9e9;
  }

  &::-webkit-scrollbar-thumb:hover {
    background-color: #0b29fb;
    border-radius: 6px;
  }
`;

export const ContainerWrapper = styled.div``;

const MOBILE = '640px';

export const SearchHeader = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const SearchRow = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;

  @media (max-width: ${MOBILE}) {
    flex-direction: column;
    align-items: stretch;
    gap: 12px;
  }
`;

export const SearchField = styled.div`
  flex: 1 1 auto;
  min-width: 200px;
  max-width: 580px;

  @media (max-width: ${MOBILE}) {
    min-width: 0;
    max-width: none;
  }
`;

export const RowDivider = styled.span`
  margin-left: auto;
  align-self: stretch;
  width: 0;
  min-height: 32px;
  border-left: 1px dashed #d9d9d9;
  flex-shrink: 0;

  @media (max-width: ${MOBILE}) {
    display: none;
  }
`;

export const SectionDivider = styled.div`
  height: 0;
  border-top: 1px dashed #d9d9d9;
`;

export const BlockedBasesWrap = styled.div`
  margin-top: 16px;
`;

export const IrregularCard = styled.div`
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  width: 100%;
  padding: 16px;
  background: ${blockingColors.surface};
  border-radius: ${blockingMetrics.radius};

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
  }
`;

export const IrregularInfo = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 16px;
  min-width: 0;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
    width: 100%;
  }
`;

export const IrregularPin = styled.span`
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  border-radius: 1000px;
  background: ${blockingColors.iconCircle};
  color: ${blockingColors.iconGlyph};

  svg {
    width: 24px;
    height: 24px;
  }
`;

export const IrregularTexts = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  min-width: 0;
`;

export const IrregularTitle = styled.strong`
  font-family: 'Mangueira', sans-serif;
  font-size: 16px;
  font-weight: 700;
  line-height: 25px;
  color: ${blockingColors.text};
`;

export const IrregularSubtitle = styled.span`
  font-family: 'Mangueira', sans-serif;
  font-size: 12px;
  line-height: 19px;
  color: ${blockingColors.text};
`;

export const IrregularActions = styled.div`
  flex-shrink: 0;

  @media (max-width: 768px) {
    width: 100%;
  }
`;

export const TechnicalAssistanceButton = styled.button`
  box-sizing: border-box;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 267px;
  min-width: 98px;
  max-width: 340px;
  height: 48px;
  padding: 12px 16px;
  border: 1px solid ${blockingColors.actionBlue};
  border-radius: ${blockingMetrics.radiusPill};
  background: ${blockingColors.actionBlue};
  font-family: 'Mangueira', sans-serif;
  font-size: 16px;
  font-weight: 700;
  line-height: 24px;
  color: ${blockingColors.white};
  cursor: pointer;

  @media (max-width: 768px) {
    width: 100%;
    max-width: none;
  }
`;
